import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";

export const interfaceConfig: InterfaceConfig = {
  name: "micredimoto",
  home_url: "/seleccionar_moto",
  aviso_privacidad: import.meta.env.VITE_URL_HOME_LENDIA + "/aviso-de-privacidad",
  terminos_condiciones: import.meta.env.VITE_URL_HOME_LENDIA + "/terminos-y-condiciones",
  interest_rate: 30,
  textos_tofu: {
    pm: {
      registro_datos_personales: {
        titulo: "Datos personales",
        sub_titulo: "",
      },
    },
  },
  companyNames: ["Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
  firma: {
    provider: "mifiel",
  },
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_6kAqm3FCR",
      userPoolClientId: "1pocu5jupbdcl4snbqmh7p57mi",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_hwd0317q9",
      userPoolClientId: "793evlodk5ulsoebmmp549if6t",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
};
